module.exports = __webpack_public_path__ + "img/header_m.d2ba3900.png";